
import { language as lan_copyright } from "./copyright";
/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    // 图片版权声明
    ...lan_copyright,
    BUILDER_PROPERTY: "PROPERTY",
    BUILDER_DESIGN_NAME: "Design Name:",
    BUILDER_COPYRIGHT: "Copyright of your images",
    BUILDER_CANCEL_BTN: "Cancel",
    BUILDER_ADD_TO_CART_BTN: "Add To Cart",
    BUILDER_UPDATE_BTN: "Update",
    /*************************** 参数校验 *************************/
    // builderUrl地址参数校验提示
    BUILDER_URL_INVALID_PARAM_TITLE: "Invalid URL",
    // builderUrl地址参数缺失
    BUILDER_URL_PARAM_MISSING_CONTENT: "The product design tool URL is invalid. Please return to the {{pageName}} page and try again. If you need further assistance, feel free to contact our support team at {{supportmail}}.",
    // builderUrl地址参数错误
    // BUILDER_URL_PARAM_ERROR_CONTENT: "The parameter is not correct when you are trying to open our online designer, please refresh the page and try again.",
    // A104P001
    // 参数缺失--一个 A104P001
    "A104P001_1": "The \"{{missingField}}\" is missing when trying to open the product design tool.",
    // 参数缺失--多个 A104P002
    "A104P001_2": "The {{missingFields}} are missing when trying to open the product design tool.",
    // A104P002
    // 参数错误--一个 A104P003 
    "A104P002_1": "The page {{correctField}} is not supported when trying to open the product design tool. Please ensure you are accessing the tool from a supported page.",
    // 参数错误-- 多个 A104P005
    // "A104P002_2": "The parameters {{correctFields}} are not correct when you are trying to open our online designer.",
    /*************************** builder页面初始化 *************************/
    BUILDER_ISSUE_PAGE_LOADING_TITLE: "Page Loading Issue",
    BUILDER_ISSUE_PAGE_LOADING_CONTENT: "An issue occurred while loading this page. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",

    // ifeamebuilder高度获取失败提示
    "A104O001": "The height of the \"iframe\" element is not defined when opening the product design tool.",
    // window对象获取失败提示，无法添加保存在线设计事件监听（builder-V5及以上版本）--打开产品设计
    "A104O002": "The window object is not defined when opening the product design tool.",
    // productInstance实例不存在
    "A104A004": "The design you're looking for could not be found, or the design ID is incorrect. If this issue persists, please contact our support team at {{supportmail}}.",
    // 产品配置问题
    "A104A005": "The product configuration does not comply with the product design tool.",
    //初始化在线设计参数-token参数缺失 A104B002
    "A104B002": "Your access rights are either invalid or have expired. Please check your login info and try again.",
    // 用户token过期
    BUILDER_MISSING_AUTHENTICATION_TITLE: "Access Denied",
    BUILDER_MISSING_AUTHORIZED_AUTHENTICATION_CONTENT: "Your access rights are either invalid or have expired. Please click \"{{okBtn}}\" to log in again.",

    // 项目名称格式不正确（1-20） projectName格式提示信息 
    BUILDER_PROJECT_NAME_FORMAT_TITLE: "Invalid design name",
    BUILDER_PROJECT_NAME_FORMAT_CONTENT: "The online design name format is incorrect. Please ensure the name length is between 1 and 20 characters.",

    // 设计保存失败 Design Saving Issue
    //保存在线设计失败提示_可重试
    BUILDER_SAVE_DESIGN_ERROR_TITLE: "Design Saving Issue",
    BUILDER_SAVE_DESIGN_ERROR_CONTENT: "An error occurred while trying to save your design. Please click \"{{retryBtn}}\" to try again, or contact our support team at {{supportmail}}.",
    BUILDER_SAVE_DESIGN_ERROR_CONTENT2: "An error occurred while trying to save your design. Please try again. If the issue persists, contact our support team at {{supportmail}}.",

    "A104P005": "The product design tool could not load because the iframe window is not defined.",

    // 添加产品到购物车失败提示_可重试
    BUILDER_ADD_TO_CART_ERROR_TITLE: "Add to cart issue",
    BUILDER_ADD_TO_CART_ERROR_CONTENT: "An error occurred while trying to add the product to your shopping cart. Please \"{{retryBtn}}\" to try again. If the issue persists, contact our support team at {{supportmail}}.",
    BUILDER_ADD_TO_CART_ERROR_CONTENT2:"An error occurred while trying to add the product to your shopping cart. Please try again. If the issue persists, contact our support team at {{supportmail}}.",
    // 产品配置问题
    "A104B2700401": "The product configuration is not set correctly. Please review and adjust the settings before proceeding.",
    // 产品购买数量小于“最小购买数量”
    "A104B2700419": "The purchase quantity is less than the minimum order quantity. Please adjust the quantity and try again.",
    // 产品不是一个成品产品（产品未完成定制），无法添加到购物车
    "A104B200064": "The product is currently in an incomplete state, please complete the customization and try again.",
    // 产品计价问题
    "A104B1200001": "The product has been calculated incorrectly. Please contact our support team at {{supportmail}} for assistance.",

    // 更新购物车项设计失败提示
    BUILDER_UPDATE_CART_ITEM_ERROR_TITLE: "Update cart item issue",
    BUILDER_UPDATE_CART_ITEM_ERROR_CONTENT: "An error occurred while trying to update the product to your shopping cart. Please \"{{retryBtn}}\" to try again. If the issue persists, contact our support team at {{supportmail}}.",
    BUILDER_UPDATE_CART_ITEM_ERROR_CONTENT2: "An error occurred while trying to update the product to your shopping cart. Please try again. If the issue persists, contact our support team at {{supportmail}}.",

    // 更新订单项设计失败提示
    BUILDER_UPDATE_ORDER_ITEM_ERROR_TITLE: "Update order item issue",
    BUILDER_UPDATE_ORDER_ITEM_ERROR_CONTENT: "An error occurred while trying to update the product to your order. Please \"{{retryBtn}}\" to try again. If the issue persists, contact our support team at {{supportmail}}.",
    BUILDER_UPDATE_ORDER_ITEM_ERROR_CONTENT2: "An error occurred while trying to update the product to your order. Please try again. If the issue persists, contact our support team at {{supportmail}}.",
    // 修改的订单项:id,对应的实体不存在 || 修改的ProductInstance:id对应的实体不存在
    "A104B311874": "The design you're looking for could not be found, or the design ID is incorrect. If this issue persists, please contact our support team at {{supportmail}}.",



    /*************************************TODO 下方提示信息尚未修改（香港）*************************************/

    /*************************** builder页面在线设计初始化 *************************/
    // BUILDER_ISSUE_ONLINE_DESIGNER_TITLE: "Page Loading Issue",
    // BUILDER_ISSUE_ONLINE_DESIGNER_CONTENT: "Opps! An error occurred when we were trying to open the online designer, please refresh the page and try again.",


    BUILDER_ISSUE_ONLINE_DESIGNER_LOADING_TITLE: "Issue of online designer",
    BUILDER_ISSUE_ONLINE_DESIGNER_LOADING_CONTENT: "An issue occurred while loading this online designer, Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",

    // iframeWindow对象获取失败提示（builder-V5以下版本）--打开产品设计
    "A104P004": "The window of the 'iframe' element is not define while we were trying to load the online designer.",

    /*************************** builder页面在线设计初始化 *************************/


    /*************************** builder页面在线设计参数校验 *************************/
    BUILDER_ONLINE_DESIGNER_INVALID_PARAM_TITLE: "Issue of online designer",
    // 参数缺失
    BUILDER_ONLINE_DESIGNER_INVALID_PARAM_CONTENT: "Missing parameters when you are trying to open our online designer, please refresh the page and try again.",
    // 参数错误
    BUILDER_ONLINE_DESIGNER_INVALID_PARAM_ERROR_CONTENT: "The parameter is not correct when you are trying to open our online designer, please refresh the page and try again.",

    // iframeBuilder定制区域初始化参数缺失 | iframeBuilder定制区域初始化参数缺失_缺少必填ID信息（propertyModelId、productId、productInstanceId、storeProductId、orderItemId）
    //初始化在线设计参数Id类型缺失 A104B001
    "A104B001": "The parameter '{{missingField}}' is missing when you are trying to open our online designer.",

    // iframeBuilder定制区域初始化参数缺失_根路径地址格式不正确
    'A104B003': "The parameter '{{correctField}}' is not correct when you are trying to open our online designer.",

    /*************************** builder页面保存在线设计 *************************/
    //保存在线设计失败提示_不可重试
    BUILDER_SAVE_DESIGN_FAILED_CONTENT: "Opps! An error occurred when we were trying to save the online designer, please try again or contact our technical support {{supportmail}}.",
    //保存在线设计失败提示_在线定制类型暂不支持
    "A104B004": "The parameter 'source' is not correct when we were trying to save the online designer.",







    // 添加产品到购物车失败提示_可重试（产品配置）
    BUILDER_ADD_TO_CART_ERROR_FAILED_TITLE: "Invalid add to cart",
    BUILDER_ADD_TO_CART_ERROR_DY_PRODUCT_CONTENT: "Opps! An error occurred when we were trying to add the product to shopping cart, please try again later.",





};

export { language }